import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Email from "./pages/Email";
import TattooConsentForm from "./components/TattooConsentForm"; // your existing form

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-black">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/email" element={<Email />} />
          <Route path="/consent" element={<TattooConsentForm />} />
        </Routes>
      </div>
    </Router>
  );
}
